// extracted by mini-css-extract-plugin
export var bottomBorder = "Content15-module--bottom-border--4b3d8";
export var ourWorkSpRow = "Content15-module--our-work-sp-row--3276e";